import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { BrowsePage } from './BrowsePage';

// Catalog browse with a top filter bar and a card grid, mounted at "/browse"
// and reached from the sidebar "Catalog" item. The stock catalog table stays
// at /catalog via app-config, which is also where entity pages live
// (/catalog/:namespace/:kind/:name) — so this page cannot take that path.
//
// It owned "/" until the home page replaced it there: the catalog answers
// "find this specific thing", which is the wrong assumption for a landing page.
//
// The default plugin header strip is deliberately NOT hidden: it is where
// Backstage renders the breadcrumb trail, the same strip that shows
// "Create › Start" on the scaffolder.
export const browsePage = PageBlueprint.make({
  name: 'browse',
  params: {
    path: '/browse',
    loader: async () => <BrowsePage />,
  },
});
